import classNames from 'classnames';


import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

import { SKELETON_BY_TAB } from 'containers/admin/clients/client/tabs-components/critical-populations/critical-populations.constants';
import type { CaptureListTab } from 'containers/admin/clients/client/tabs-components/critical-populations/critical-populations.types';

interface CaptureListSkeletonProps {
  tab: CaptureListTab;
}

const CaptureListSkeleton = ({ tab }: CaptureListSkeletonProps) => {
  const {
    cardCount,
    cardHeightClass,
    hasReasonBlock,
    hasToolbar,
    buttonCount,
  } = SKELETON_BY_TAB[tab];

  return (
    <Stack
      sx={[{ gap: 1.5 }, !hasToolbar && { mt: 0.5 }]}
      aria-busy="true"
      data-testid="capture-list-skeleton"
    >
      {hasToolbar && (
        <Stack
          direction="row"
          sx={{ alignItems: 'flex-end', justifyContent: 'space-between' }}
          data-testid="capture-list-skeleton-toolbar"
        >
          <Box
            sx={{
              width: '200px',
              height: '1.25rem',
              borderRadius: '0.25rem',
              bgcolor: 'tokens.gray.100',
            }}
          />
          <Box
            sx={{
              width: '136px',
              height: '2.5rem',
              borderRadius: '0.25rem',
              bgcolor: 'tokens.gray.100',
            }}
          />
        </Stack>
      )}
      {Array.from({ length: cardCount }, (_, index) => (
        <div
          key={index}
          className={classNames(
            'overflow-hidden rounded-[10px] border border-navy-100 bg-white shadow-[0_1px_2px_rgba(0,0,0,0.05)]',
            cardHeightClass
          )}
        >
          <Stack sx={{ gap: 0.5, px: 2, pb: 1.5, pt: 2 }}>
            <Stack direction="row" sx={{ gap: 0.5 }}>
              <Box
                sx={{
                  width: '65px',
                  height: '1.25rem',
                  borderRadius: '0.25rem',
                  bgcolor: 'tokens.gray.100',
                }}
              />
              <Box
                sx={{
                  width: '5rem',
                  height: '1.25rem',
                  borderRadius: '0.25rem',
                  bgcolor: 'tokens.gray.100',
                }}
              />
            </Stack>
            <Box
              sx={{
                width: '380px',
                height: '1.5rem',
                maxWidth: '100%',
                borderRadius: '0.25rem',
                bgcolor: 'tokens.gray.200',
              }}
            />
            <Box
              sx={{
                width: '425px',
                height: '0.75rem',
                maxWidth: '100%',
                borderRadius: '0.25rem',
                bgcolor: 'tokens.gray.100',
              }}
            />
            <Box
              sx={{
                width: '100px',
                height: '0.75rem',
                borderRadius: '0.25rem',
                bgcolor: 'tokens.gray.200',
              }}
            />
            {hasReasonBlock && (
              <Box
                sx={{
                  height: '4rem',
                  borderRadius: '0.25rem',
                  bgcolor: 'tokens.gray.100',
                }}
              />
            )}
          </Stack>
          <Stack direction="row" sx={{ gap: 1.5, px: 2, pb: 2, pt: 1.5 }}>
            {Array.from({ length: buttonCount }, (_, buttonIndex) => (
              <Box
                key={buttonIndex}
                sx={{
                  width: '120px',
                  height: '2rem',
                  borderRadius: '0.25rem',
                  bgcolor: 'tokens.gray.100',
                }}
              />
            ))}
          </Stack>
        </div>
      ))}
    </Stack>
  );
};

export default CaptureListSkeleton;
